import React, { createContext, useContext, useEffect, useReducer } from "react";
import ContentBody from "./ContentBody";
import { AuthContext } from "../../App/App";
import * as io from "socket.io-client";
import jwt from 'jwt-decode'
import axios from 'axios'
import swal from 'sweetalert';

const CONNECTION_PORT = "https://helpdesk-api.umy.ac.id/";
// const CONNECTION_PORT = 'http://localhost:4122/';

export const ContentBodyContext = createContext();

function MainContent() {
  //TODO: internal server erre, shoutdown UI
  const { stateAuth, dispatchAuth } = useContext(AuthContext)

  //=========== Whatsapp Auth ====================
  const initialWhastappAuth = {
    status: false,
  }
  //=========== End Whatsapp Auth ====================

  const initialState = {
    trigger: null,
    socket: undefined,
    workunitName: undefined,
    workunitAcronym: undefined,
    whatsappContact: null,
    whatsappContactId: null,
    whatsappAuth: initialWhastappAuth,
  }

  const reducer = (state, action) => {
    switch (action.type) {
      //Whatsapp Auth
      case "WA_STATUS":
        return {
          ...state,
          whatsappAuth: {
            status: action.status,
          },
          trigger: action.trigger
        }

      //Global
      case "TRIGGER":
        return {
          ...state,
          trigger: action.trigger
        }
      case 'SOCKET':
        return {
          ...state,
          socket: action.socket
        }
      case 'WHATSAPP_CONTACT':
        return {
          ...state,
          whatsappContactId: action.whatsappContactId,
          whatsappContact: action.whatsappContact
        }
      case 'WORK_UNIT':
        return {
          ...state,
          workunitName: action.workunitName,
          workunitAcronym: action.workunitAcronym,
          whatsappContactId: action.whatsappContactId,
          whatsappContact: action.whatsappContact
        }
      default: return state
    }
  }
  const [stateContentBody, dispatchContentBody] = useReducer(reducer, initialState)

  //init socket
  useEffect(() => {
    dispatchContentBody({
      type: "SOCKET",
      socket: io(CONNECTION_PORT)
    })
  }, [CONNECTION_PORT])

  //Get workunit info
  useEffect(() => {
    if (stateContentBody.socket && stateContentBody.whatsappAuth.status == false && Number.isInteger(jwt(localStorage.getItem('token-helpdesk-umy')).role_id)) {
      const config = {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'x-access-token': localStorage.getItem('token-helpdesk-umy')
        }
      }
      axios.get('/api/v1/helpdesk/dashboard/workunit', config)
        .then(async res => {
          dispatchContentBody({
            type: "WORK_UNIT",
            workunitName: res.data.data.work_unit_name,
            workunitAcronym: res.data.data.work_unit_acronym,
            whatsappContactId: res.data.data.whatsappContactId,
            whatsappContact: res.data.data.whatsappContact,
          })
        })
        .catch(err => {
          if (!err.response || err.code === 'ECONNABORTED') {
            swal("Error!", "Check Your Internet Connection!", "error", {
              button: "OK",
            });
          } else if (err.response) {
            if (err.response.data.status === 'jwt' && err.response.data.message === `TokenExpiredError`) {
              dispatchAuth({
                type: "LOGOUT",
                message: 'Token expired, please login again!!!'
              })
            } else if (err.response.data.message) {
              swal("Error!", `${JSON.stringify(err.response.data.message)}`, "error", {
                button: "OK",
              });
            }
          }
        })
    } else if (stateContentBody.socket && !Number.isInteger(jwt(localStorage.getItem('token-helpdesk-umy')).role_id)) {

      //TODO: get image
    }
  }, [stateContentBody.socket])

  //store id
  useEffect(() => {
    if (stateContentBody.socket) {
      const token = jwt(localStorage.getItem('token-helpdesk-umy'))
      stateContentBody.socket.emit('socket-join', {
        id: (token.role_id == 'staff' || token.role_id) == 'student' ? token.id : token.work_unit_id,
        admin_id: (token.role_id == 'staff' || token.role_id) == 'student' ? null : token.id,
        is_umy: token.is_umy
      })
    }
  }, [stateContentBody.socket])


  return (
    <div className="main-content">
      <section className="section">
        <ContentBodyContext.Provider value={{ stateContentBody, dispatchContentBody }}>
          <ContentBody />
        </ContentBodyContext.Provider>
      </section>
    </div>
  )
}

export default MainContent

